export default __webpack_public_path__ + "search-examples-mapbox-mapview-thumbnail-480-727ecc9d46063516d1c72151879c60d4.webp";